import { useState, useCallback, useEffect } from "react";
import { getMembers, removeMember, makeOwner, type AccountMember } from "../api/members";

export function useMembers() {
    const [members, setMembers] = useState<AccountMember[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [removingId, setRemovingId] = useState<number | null>(null);
    const [transferringId, setTransferringId] = useState<string | null>(null);

    const refetch = useCallback(async () => {
        setLoading(true);
        setError(null);
        const result = await getMembers("active");
        setLoading(false);
        if (Array.isArray(result)) {
            setMembers(result);
        } else {
            setError(result.error);
        }
    }, []);

    useEffect(() => {
        refetch();
    }, [refetch]);

    const remove = useCallback(async (member: AccountMember) => {
        if (!window.confirm(`Remove ${member.email ?? member.user_id} from the account?`)) return;
        setRemovingId(member.id);
        const result = await removeMember(member.id);
        setRemovingId(null);
        if (result.ok) {
            void refetch();
        } else {
            setError(result.error);
        }
    }, [refetch]);

    const transfer = useCallback(async (member: AccountMember) => {
        if (!window.confirm(`Transfer account ownership to ${member.email ?? member.user_id}? You will become a regular member.`)) return;
        setTransferringId(member.user_id);
        const result = await makeOwner(member.user_id);
        setTransferringId(null);
        if (result.ok) {
            void refetch();
            window.location.reload();
        } else {
            setError(result.error);
        }
    }, [refetch]);

    return { members, loading, error, refetch, remove, removingId, transfer, transferringId };
}

